import { Drawer } from '@mui/material';
import { FiTrash2, FiX } from 'react-icons/fi';
import { PrimaryButton, SecondaryButton } from '../../../../shared/ui/Inputs';
import { PrimaryTitleGray } from '../../../../app/theme/tokens/colors';
import { SkuTag } from './catalogStyles';

export const CartDrawer = ({ open, onClose, cart, onUpdateQuantity, onRemove, onConfirm }) => {
    return (
        <Drawer anchor="right" open={open} onClose={onClose} transitionDuration={{ enter: 260, exit: 200 }}>
            <div
                style={{
                    width: 'min(420px, 92vw)',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    background: '#fff',
                }}
            >
                <div
                    style={{
                        padding: '20px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        borderBottom: '1px solid #e5e5e5',
                    }}
                >
                    <h3 style={{ margin: 0, color: PrimaryTitleGray }}>Seu carrinho</h3>
                    <button
                        aria-label="Fechar carrinho"
                        onClick={onClose}
                        style={{ border: 0, background: 'transparent', cursor: 'pointer', fontSize: '22px' }}
                    >
                        <FiX />
                    </button>
                </div>

                <div style={{ flex: 1, overflow: 'auto', padding: '16px 20px' }}>
                    {cart.length === 0 ? (
                        <p style={{ color: '#666', textAlign: 'center', marginTop: '40px' }}>
                            Seu carrinho está vazio.
                        </p>
                    ) : (
                        cart.map((item) => (
                            <div
                                key={item.lineId}
                                style={{ display: 'flex', gap: '12px', padding: '14px 0', borderBottom: '1px solid #eee' }}
                            >
                                <img
                                    src={item.image}
                                    alt=""
                                    style={{ width: '62px', height: '62px', objectFit: 'cover', borderRadius: '6px' }}
                                />
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <strong style={{ display: 'block', color: PrimaryTitleGray }}>{item.name}</strong>
                                    <span style={{ display: 'flex', alignItems: 'center', gap: '7px', color: '#666', fontSize: '13px', marginTop: '5px', flexWrap: 'wrap' }}>
                                        <SkuTag>{item.sku}</SkuTag>
                                    </span>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '10px' }}>
                                        <SecondaryButton
                                            aria-label={`Diminuir quantidade de ${item.name}`}
                                            onClick={() => onUpdateQuantity(item.lineId, item.quantity - 1)}
                                            style={{ minWidth: '30px', padding: 0 }}
                                        >
                                            −
                                        </SecondaryButton>
                                        <span style={{ minWidth: '20px', textAlign: 'center' }}>{item.quantity}</span>
                                        <SecondaryButton
                                            aria-label={`Aumentar quantidade de ${item.name}`}
                                            onClick={() => onUpdateQuantity(item.lineId, item.quantity + 1)}
                                            style={{ minWidth: '30px', padding: 0 }}
                                        >
                                            +
                                        </SecondaryButton>
                                        <button
                                            aria-label={`Remover ${item.name}`}
                                            onClick={() => onRemove(item.lineId)}
                                            style={{ marginLeft: 'auto', color: '#b34141', border: 0, background: 'transparent', cursor: 'pointer' }}
                                        >
                                            <FiTrash2 />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>

        <div style={{ borderTop: '1px solid #e5e5e5', padding: '20px' }}>
          <PrimaryButton
            disabled={cart.length === 0}
            onClick={onConfirm}
            style={{ width: '100%', height: '42px' }}
          >
            Confirmar pedido
          </PrimaryButton>
        </div>
      </div>
    </Drawer>
  );
};
